import { useCallback, useMemo, useState } from 'react'
import { PAGE_SIZE } from '../../api'

/** 服务端分页：页码 + 每页条数（Table / 独立 Pagination 共用） */
export function useServerPagination(initialPageSize = PAGE_SIZE) {
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(initialPageSize)

  const handlePaginationChange = useCallback(
    (p: number, ps?: number) => {
      const nextSize = ps ?? pageSize
      if (nextSize !== pageSize) {
        setPageSize(nextSize)
        setPage(1)
      } else {
        setPage(p)
      }
    },
    [pageSize],
  )

  const paginationOptions = useMemo(
    () => ({ pageSize, showSizeChanger: true as const }),
    [pageSize],
  )

  const resetPage = useCallback(() => setPage(1), [])

  return {
    page,
    setPage,
    pageSize,
    setPageSize,
    handlePaginationChange,
    paginationOptions,
    resetPage,
  }
}
